export const faqs = [
  {
    question: 'How do I receive Pastry Instructor Ready?',
    answer:
      'You receive digital access after your purchase so you can start using the material immediately.',
  },
  {
    question: 'What format is the material?',
    answer: 'The teaching system is delivered in ready-to-use PDF format.',
  },
  {
    question: 'Is it for students or instructors?',
    answer:
      'It was created specifically for pastry instructors, baking educators, culinary teachers and pastry chefs who teach.',
  },
  {
    question: 'What levels does it cover?',
    answer: 'Beginner through advanced.',
  },
  {
    question: 'Is the material visual?',
    answer:
      'Yes. The system is designed around visual demonstrations, comparisons, progressions, corrections and process-based teaching material.',
  },
  {
    question: 'Does it include ready-to-teach classes?',
    answer: 'Yes. It includes 150 ready-to-teach pastry lessons.',
  },
  {
    question: 'Are the bonuses included?',
    answer:
      'Yes. All 5 professional bonus guides are included in this offer.',
  },
  {
    question: 'Is it a subscription?',
    answer: 'No. It is a one-time payment.',
  },
]
